import { forEach, isEmpty, isEqual, set } from 'lodash';

export class Adapter {
  #logger;

  constructor({ logger }) {
    this.#logger = logger;
  }

  trackEvent(eventName, eventData) {}
  trackClick(event, eventName, eventData) {}
  trackFormEvent(event, $form, eventName, eventData) {}
  trackFormSubmit(event, $form, onSubmitEventName, onSubmitEventData) {}
  trackGFFormConfirmation(event, formId) {}

  log(...message) {
    this.#logger.debug(...message);
  }

  logEvent(eventType, ...message) {
    this.#logger.debugEvent(eventType, ...message);
  }

  #fieldIDRegex = /{{\s*field_id:(\d+)\s*}}/g;

  convertDataToFieldData(data, $form) {
    const d = {};

    forEach(data, (value, key) => {
      if (isEqual(key, '__data__')) {
        return;
      }

      const newValue = value.replaceAll(this.#fieldIDRegex, (...args) => {
        const [str, p1] = args;
        const inputName = `input_${p1}`;
        const $input = $form.find(`[name=${inputName}]`);

        return !isEmpty($input) ? $input.val() : str;
      });

      set(d, key, newValue);
    });

    return d;
  }
}
